import React, {Component} from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Slider from 'react-input-slider';

import {
    changeDuration,
    changeFreezing,
    setDayStatus,
    setStudentStatus,
    setFamilyStatus,
    setCustomStatus
} from '../../actions/card';

import { separate } from '../../helpers/separate';

import './styles/settings.scss';
import {Privileges} from "../Card/Privileges";
import {eventGoToForm} from "../../helpers/analytics"
// import {checkIsTablet} from "../../helpers/checkMobile";

class Settings extends Component {

    constructor(props) {
        super(props)

        this.state = {
            monthDurationMin: 3,
            monthDurationMax: 12,
            monthFreezingMin: 0,
            monthFreezingMax: 3,

            durationValue: this.props.duration || 12,
            freezingValue: this.props.freezing || 0,
        }

        this.totalCost = this.totalCost.bind(this);
    }

    componentDidUpdate(prevProps) {
        if (prevProps.custom !== this.props.custom) {
            this.setState({
                durationValue: this.props.duration || 12,
                freezingValue: this.props.freezing || 0,
            })
        }
    }

    // return cost for one month relative count month
    calculateOneMonth(data) {
        let cost;

        data.cost_month.forEach(item => {
            if (this.state.durationValue >= item.minMonth && this.state.durationValue <= item.maxMonth) {
                cost = item.cost;
            }
        })

        return cost;
    }

    calculateDiscount(data) {
        let discount;

        data.forEach(item => {
            if (this.state.durationValue >= item.minMonth && this.state.durationValue <= item.maxMonth) {
                discount = item.discount;
            }
        })

        return discount;
    }

    totalCost(data) {
        let monthCost = +this.calculateOneMonth(data) * this.state.durationValue;
        let freezingCost = +data.cost_freezing * this.state.freezingValue;
        let totalCost = monthCost + freezingCost

        if (this.state.studentStatus) {
            totalCost -= totalCost * this.calculateDiscount(this.props.mainData.discounts.student) / 100
        } else if (this.state.dayDiscount) {
            totalCost -= totalCost * this.calculateDiscount(this.props.mainData.discounts.day) / 100
        } else if (this.state.familyDiscount) {
            totalCost -= totalCost * this.calculateDiscount(this.props.mainData.discounts.family) / 100
        }

        return totalCost;
    }

    choiceDayDiscount(flag) {
        this.setState({
            dayDiscount: flag
        }, () => {
            this.props.setDayStatus(flag);
            if (flag) {
                this.choiceStudentStatus(false)
                this.choiceFamilyStatus(false)
            }
            this.props.changeMaxStep(2);
            this.props.setCustomStatus(true)
        })
    }

    choiceStudentStatus(flag) {
        this.setState({
            studentStatus: flag
        }, () => {
            this.props.setStudentStatus(flag);
            if (flag) {
                this.choiceDayDiscount(false)
                this.choiceFamilyStatus(false)
            }
            this.props.changeMaxStep(2);
            this.props.setCustomStatus(true)
        })
    }

    choiceFamilyStatus(flag) {
        this.setState({
            familyDiscount: flag
        }, () => {
            this.props.setFamilyStatus(flag);
            if (flag) {
                this.choiceDayDiscount(false)
                this.choiceStudentStatus(false)
            }
            this.props.changeMaxStep(2);
            this.props.setCustomStatus(true)
        })
    }

    render() {

        const {
            resultCard,
            changeDuration,
            changeFreezing,
            changeStep,
            changeMaxStep,
            dayDiscount,
            studentStatus,
            familyDiscount,
            custom,
            setCustomStatus
        } = this.props;

        let costMonth;

        costMonth = this.calculateOneMonth(resultCard);

        return(
            <div className="container">
                <div className="settings">
                    <div className="settings__title">
                        <h2>Настрой свой тариф или выбери готовый</h2>
                    </div>
                    <div className="settings__tabs">
                        <div className={`settings__tabs__item ${custom ? '' : '_active'}`} onClick={() => setCustomStatus(false)}>Готовое<br/>предложение</div>
                        <div className={`settings__tabs__item ${custom ? '_active' : ''}`} onClick={() => setCustomStatus(true, true)}>Настроить<br/>свой тариф</div>
                    </div>
                    <div className={`settings__params`}>
                        <h3 dangerouslySetInnerHTML={{__html: custom ? 'Мой тариф' : resultCard.title.replace('/', '<span style="color: #DD0031">/</span>')}}/>
                        <div className="settings__params__cost">
                            <div className="month-cost"><span className="amount">{separate(costMonth)}</span> ₽ / мес</div>
                            <div className="big-slash">/</div>
                            <div className="total">
                                <div className="cost"><span className="amount">{`${separate(this.totalCost(resultCard))}`}</span> ₽</div>
                                <div className="comment">стоимость полной карты</div>
                            </div>
                        </div>
                        <div className="settings__params__item">
                            <div className="settings__params__content _duration">
                                <p className="_month" style={{paddingLeft: ((this.state.durationValue - 3)/9 * 100) + '%'}}><span>{this.state.durationValue}</span> мес.</p>
                                <div className="settings__params__content__slider">
                                    <Slider
                                        axis="x"
                                        x={this.state.durationValue}
                                        xmin={this.state.monthDurationMin}
                                        xmax={this.state.monthDurationMax}
                                        onChange={value =>  {
                                            this.setState({ durationValue: value.x });
                                            changeDuration(value.x);
                                            changeMaxStep(2);
                                            setCustomStatus(true)
                                        }}
                                        styles={{
                                            track: {
                                                backgroundColor: '#557CD8',
                                                borderRadius: 0,
                                                height: '4px'
                                            },
                                            active: {
                                                backgroundColor: '#BDBDBD',
                                                borderRadius: 0,
                                                height: '4px'
                                            }
                                        }}
                                    />
                                </div>
                            </div>
                            <div className="settings__params__title">
                                <p>Выбери срок действия карты</p>
                            </div>
                        </div>
                        <div className="settings__params__item">
                            <div className="settings__params__content _freezing">
                                <p className="_month _freezing" style={{paddingLeft: (this.state.freezingValue/3 * 100) + '%'}}><span>{this.state.freezingValue}</span> мес.</p>
                                <div className="settings__params__content__slider _freezing">
                                    <Slider
                                        axis="x"
                                        x={this.state.freezingValue}
                                        xmin={this.state.monthFreezingMin}
                                        xmax={this.state.monthFreezingMax}
                                        onChange={value =>  {
                                            this.setState({ freezingValue: value.x });
                                            changeFreezing(value.x);
                                            changeMaxStep(2);
                                            setCustomStatus(true)
                                        }}
                                        styles={{
                                            track: {
                                                backgroundColor: '#557CD8',
                                                borderRadius: 0,
                                                height: '4px'
                                            },
                                            active: {
                                                backgroundColor: '#BDBDBD',
                                                borderRadius: 0,
                                                height: '4px'
                                            }
                                        }}
                                    />
                                </div>
                            </div>
                            <div className="settings__params__title">
                                <p>Выбери количество месяцев заморозки</p>
                            </div>
                        </div>

                        <div className="settings__params__options">
                            <h3>Добавить опцию</h3>

                            <div className="option">
                                <div><input type="checkbox" id="day-discount-toggle" className="toggle-button" checked={dayDiscount} onChange={e => this.choiceDayDiscount(e.target.checked)} /></div>
                                <label htmlFor="day-discount-toggle"><b>Время посещения</b><br/>(будни 7:00-17:00/ 21:00-23:00, выходные без ограничений)</label>
                            </div>
                            <div className="option">
                                <div><input type="checkbox" id="student-toggle" className="toggle-button" checked={studentStatus} onChange={e => this.choiceStudentStatus(e.target.checked)} /></div>
                                <label htmlFor="student-toggle"><b>Тариф студенческий</b><br/>(при предъявлении студенческого)</label>
                            </div>
                            <div className="option">
                                <div><input type="checkbox" id="family-toggle" className="toggle-button" checked={familyDiscount} onChange={e => this.choiceFamilyStatus(e.target.checked)} /></div>
                                <label htmlFor="family-toggle">Тариф семейный (от 2х карт 16+)</label>
                            </div>
                        </div>

                        <Privileges privileges={resultCard.privileges}></Privileges>

                        <div className="settings__next">
                            <button
                                type="button"
                                onClick={async () => {
                                    eventGoToForm();
                                    await changeStep(3);
                                }}
                            >
                                <span>Перейти к оформлению</span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

function mapStateToProps(state) {
    return {
        mainData: state.card.mainData,
        resultCard: state.card.resultCard,
        custom: state.card.custom,
        duration: state.card.duration,
        freezing: state.card.freezing,
        oneVisit: state.card.oneVisit,
        dayDiscount: state.card.dayDiscount,
        studentStatus: state.card.studentStatus,
        familyDiscount: state.card.familyDiscount
    }
}
  
const mapDispatchToProps = dispatch => bindActionCreators({
    changeDuration,
    changeFreezing,
    setDayStatus,
    setStudentStatus,
    setFamilyStatus,
    setCustomStatus
}, dispatch);
  
export default connect(mapStateToProps, mapDispatchToProps)(Settings)
